import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Grid,
} from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";

export type AwsCreds = {
  key?: string;
  secret?: string;
};

export default function AwsCredsDialog(props: {
  open: boolean;
  onSubmit: (data: AwsCreds) => any;
}) {
  const { handleSubmit, register } = useForm();
  return (
    <Dialog open={props.open}>
      <form
        onSubmit={handleSubmit((data: AwsCreds) => props.onSubmit({ ...data }))}
      >
        <DialogTitle>AWS Credentials</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                type="password"
                label="Key"
                name="key"
                inputRef={register}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="password"
                label="Secret"
                name="secret"
                inputRef={register}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">Deploy</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
